export const dataUserSessionDetails = {
  type: 'object',
  required: ['UserType', 'TimeInMin', 'IsCompleted'],
  properties: {
    UserType: {
      type: 'string',
      minLength: 1,
    },
    TimeInMin: {
      type: 'string',
      minLength: 1,
    },
    IsCompleted: {
      type: 'boolean',
    },
  },
};
